"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var formatKeys = {
  MY: 'i18n.dateTime.monthAndYear',
  MD: 'i18n.dateTime.monthAndDay',
  QY: 'i18n.dateTime.quarterAndYear',
  WMDY: 'i18n.dateTime.weekDayAndMonthAndDayAndYear'
};

var _default = function _default(_ref) {
  var value = _ref.value,
      type = _ref.type,
      format = _ref.format,
      length = _ref.length;
  var momentValue = !type ? value : _I18n.default.moment[type](value);
  var monthName = '';
  var weekDay = '';
  var fullDate = '';

  if (length === 's') {
    var monthKeys = Object.keys(_I18n.default.translations.en.i18n.dateTime.shortForm.months);
    var shortMonthKey = monthKeys[momentValue.month()];
    monthName = _I18n.default.text("i18n.dateTime.shortForm.months." + shortMonthKey, {
      locale: _I18n.default.locale
    });
    weekDay = momentValue.format('ddd');
    fullDate = momentValue.format('ll');
  } else {
    monthName = momentValue.format('MMMM');
    weekDay = momentValue.format('dddd');
    fullDate = momentValue.format('LL');
  }

  var options = {
    monthName: monthName,
    locale: _I18n.default.locale
  };

  switch (format) {
    case 'MD':
      options.dayNumber = momentValue.date();
      break;

    case 'QY':
      options.quarterNumber = momentValue.quarter();
      options.yearNumber = momentValue.year().toString();
      break;

    case 'WMDY':
      options.weekDay = weekDay;
      options.fullDate = fullDate;
      break;

    default:
      options.yearNumber = momentValue.year().toString();
  }

  return _I18n.default.text(formatKeys[format], options);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/internal/utils/formatAbstractDate.js
// module id = 109
// module chunks = 209 210 211 212